<template>
  <div>
    <search :change="change" :focus="onInputFocus" :blur="onInputBlur" :showFilter="true" :showConfirm="showHot" class="search" ref="search"></search>
    <div class="content" v-onscroll="onscroll">
      <div class="filters hot" v-if="hasFilter">
        <ul>
          <li v-if="RecommendDaka">推荐大咖<i class="iconfont icon-guanbi" @click="pushRecDaka()"></i></li>
          <li v-if="Brand">{{Brand.name}}<i class="iconfont icon-guanbi" @click="pushBrand()"></i></li>
          <li v-if="Tag">{{Tag.name}}<i class="iconfont icon-guanbi" @click="pushTag()"></i></li>
          <li v-if="Activity">{{Activity.name}}<i class="iconfont icon-guanbi" @click="pushActivity()"></i></li>
          <li v-if="Type">{{Type.name}}<i class="iconfont icon-guanbi" @click="pushType()"></i></li>
          <li v-if="Category">{{Category.name}}<i class="iconfont icon-guanbi" @click="pushCategory()"></i></li>
          <li v-if="hasFilter" class="reset-btn" @click="resetFilter"><i class="iconfont icon-shuaxin"></i> 重置</li>
        </ul>
      </div>
      <div class="hot" v-if="showHot">
        <h3>热门搜索</h3>
        <ul>
          <li v-for="(h, index) in hotData" :key="index" @click="hotSearch(h.keyword)">{{h.keyword}}</li>
        </ul>
      </div>
      <!-- 组件 -->
      <search-default ref="searchDefault" v-show="!(hasFilter||keyword||showHot)"></search-default>
      <div class="mask-wrap">
        <search-result ref="searchResult" v-show="hasFilter||keyword||showHot" :isShow="!!(hasFilter||keyword||showHot)"></search-result>
        <div class="m" v-if="m" @click="m=false"></div>
      </div>
      <!-- 回到顶部 -->
      <div class="go-top" v-show="showGoTop" @click="goTop"><img src="@/common/image/go-top.png" alt=""></div>
    </div>
  </div>
</template>
<script type="text/ecmascript-6">
import Search from 'components/search/search'
import SearchDefault from './search-default'
import SearchResult from './search-result'
import {isEmptyObject, isDef} from '@/utils/misc'
import {RES_OK} from '@/api/config'
import {getHotSearch} from '@/api/index.js'
import {getInitFilterData, mapFilter, resetFilter, mapPushFilter,
  Brand, Tag, Activity, Type, Category, RecommendDaka, formatFiltersToObject} from '@/api/search'
export default {
  name: 'page-index-search',
  components: {
    Search,
    SearchDefault,
    SearchResult
  },
  data() {
    return {
      showGoTop: false,
      keyword: '',
      showHot: false,
      hotData: [],
      m: false
    }
  },
  computed: {
    ...mapFilter([Brand, Tag, Activity, Type, Category, RecommendDaka]),
    hasFilter() {
      // 有没有过滤条件
      return this.Brand || this.Tag || this.Activity || this.Type || this.Category || this.RecommendDaka
    },
    filterStr() {
      return JSON.stringify(formatFiltersToObject())
    }
  },
  watch: {
    filterStr() {
      // 过滤条件改了
      // 强制搜索
      this.change(this.keyword || '', true)
    }
  },
  created() {
    // 这个页面会缓存
  },
  activated() {
    // 处理进入搜索带了过滤条件
    this.parseFilter()
    // 处理接口数据
    // 热门标签
    this._getHotSearch()
    // 触发加载默认数据
    // this.change('', true)
  },
  mounted() {
  },
  methods: {
    ...mapPushFilter({
      pushBrand: Brand,
      pushTag: Tag,
      pushActivity: Activity,
      pushType: Type,
      pushCategory: Category,
      pushRecDaka: RecommendDaka
    }),
    resetFilter() {
      // 重置vuex 中的数据
      resetFilter()
      if (!isEmptyObject(this.$route.query)) {
        // 进入搜索是带参数的话，参数目前是过滤条件
        // 重置参数
        this.$router.replace({
          query: {}
        })
      }
    },
    resetData() {
      // 重置实例数据，添加数据的时候相应要在这里做处理
      this.keyword = ''
      this.$refs.search && (this.$refs.search.value = '')
    },
    parseFilter() {
      // 保存参数
      const inputFilter = this.$route.query
      // 处理是否重置过滤条件
      if (this.$route.params.reset) {
        // 发现需要重置过滤条件
        // 重置vuex 中的数据
        resetFilter()
        if (this.$route.params.focus) {
          this.showHot = true
          this.$nextTick(() => {
            this.$refs.search.autofocus()
          })
        }
        // 处理关键字
        const keyword = this.$route.params.keyword || this.$route.query.keyword
        if (keyword) {
          this.$nextTick(() => {
            this.$refs.search.value = keyword
          })
        }
        // 重置路由path
        this.$router.replace({
          params: {
            reset: null,
            focus: null
          },
          query: {}
        })
        // console.log('search reset')
        // 自动聚焦
        // this.$nextTick(() => {
        //   this.$refs.search.autofocus()
        // })
        // 初始化默认数据
        this.$refs.searchDefault && this.$refs.searchDefault.init()
        this.$refs.searchResult && this.$refs.searchResult.reset()
        // 重置实例数据
        this.resetData()
      }
      const opTable = {
        activities: this.pushActivity,
        categories: this.pushCategory,
        tags: this.pushTag,
        types: this.pushType
      }
      // 处理链接中带进来的过滤条件
      // console.log(inputFilter)
      // 处理搜索大咖
      if (isDef(inputFilter.search_type)) {
        this.pushRecDaka({
          search_type: inputFilter.search_type
        })
      }
      // 调接口获取所有的过滤条件数据
      // 根据id 筛选出过滤的条件
      // 最后将筛选条件设置到 vuex中
      if (!isEmptyObject(inputFilter)) {
        getInitFilterData().then(({data}) => {
          if (data.code === RES_OK && data.data) {
            const allFilter = data.data
            for (let inputFilterKey in inputFilter) {
              const id = inputFilter[inputFilterKey]
              if (allFilter[inputFilterKey]) {
                allFilter[inputFilterKey].forEach(item => {
                  // eslint-disable-next-line
                  if (item.id == id && opTable[inputFilterKey]) {
                    opTable[inputFilterKey](item)
                  }
                })
              }
            }
          } else {
            // 获取数据失败
          }
        })
      }
    },
    onInputFocus() {
      this.showHot = true
      this.m = true
    },
    onInputBlur() {
      this.showHot = false
      this.m = false
    },
    hotSearch(keyword) {
      this.$refs.search.value = keyword
    },
    change(val, force) {
      const safeRun = (condition, func) => {
        if (condition) {
          func()
        } else {
          this.$nextTick(() => func())
        }
      }
      // force 代表强制重新搜索
      if (val === this.keyword && !force) return
      this.keyword = val

      const params = formatFiltersToObject()
      // 关键字为空 并且 没有过滤条件
      const emptySearch = val.length === 0 && isEmptyObject(params)

      if (emptySearch) {
        safeRun(this.$refs.searchResult, () => this.$refs.searchResult.reset())
        return
      }

      if (!isDef(params.search_type)) {
        // 没有搜索类型
        if (val.length > 0 && isEmptyObject(params)) {
          // 关键字 并且 没有过滤条件 搜索全部
          params.search_type = 0
        } else {
          params.search_type = 1
        }
      }
      params.keywords = this.keyword
      safeRun(this.$refs.searchResult, () => this.$refs.searchResult.init(params))
    },
    _getHotSearch() {
      getHotSearch().then(res => {
        if (res.data.data.length) {
          let data = res.data.data
          this.hotData = data
        }
      })
    },
    onscroll(top) {
      // console.log(top)
      this.showGoTop = top > 600
    },
    goTop() {
      window.scrollTo(0, 0)
    }
  }
}
</script>
<style scoped lang="stylus" ref="stylesheet/stylus">
  @import "~common/stylus/variable"
  .search
    position fixed
    top 0
    left 0
    width 100%
    background #ffffff
    z-index 9
  .content
    padding-top: size(136)
  .group
    overflow hidden
    padding 0 size(30)
    padding-bottom: size(30)
    .name
      line-height size(106)
      color #333
      font-size size(30)
  .block{
    padding: 0 size(30)
    .title{
      fonts-size size(32)
      margin-bottom size(36)
      margin-top size(10)
    }
  }
  .course-block{
    .title{
      margin-bottom 0
    }
  }
  .hot{
    padding: size(40) size(30)
    h3{
      font-size: size(30)
      margin-bottom: size(40)
      color #242724
      font-weight 500
    }
    ul{
      overflow hidden
      width: 100%;
      li{
        float left
        font-size: size(26)
        padding: size(14) size(14)
        text-align center
        min-width size(116)
        margin-right: size(20)
        margin-bottom: size(20)
        border 1px solid #e7ecf5
        border-radius: 2px
        color: #454c56
      }
    }
  }
  .filters{
    padding: size(20) size(30)
    ul{
      li{
        width auto
        padding: size(14) size(18)
        padding-right 0
        .iconfont{
          font-size 12px
          color #dbdcdb
          padding 0 size(18)
        }
      }
      .reset-btn{
        padding size(14) size(0)
        min-width 0
        border none
        .iconfont{
          padding 0
          color #333
        }
      }
    }
  }
  .go-top{
    position fixed
    z-index 99
    width size(82)
    height size(82)
    overflow hidden
    right 15px
    bottom 40px
    img{
      display block
      width 100%
    }
  }
  .mask-wrap{
    position relative
    .m{
      position absolute
      left 0
      top 0
      bottom 0
      right 0
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/index/search.vue